module.exports = __webpack_public_path__ + "img/zonal_map.339ff1f0.svg";